import {Box, BoxProps} from '@mui/material';
import brickLogo from '../../assets/brickLogo.png';
import Color from 'color';
import {colors} from '@ark/react';

type LogoGreyCircleProps = BoxProps & {
  logoSrc?: string;
  logoAlt?: string;
};

export const LogoGreyCircle = ({
  logoSrc = brickLogo,
  logoAlt = 'ARK Logo',
  ...props
}: LogoGreyCircleProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: new Color(colors.hintOfRed).darken(0.01).hex(),
        borderRadius: '35px',
        width: '70px',
        height: '70px',
      }}
      {...props}
    >
      <img
        style={{
          width: 50,
        }}
        alt={logoAlt}
        src={logoSrc}
      />
    </Box>
  );
};
